import React, { useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useTheme } from 'components/core/theme-provider';
import { useConfig } from 'hooks/use-config';
import { refreshAccessToken } from 'features/auth/services/auth-service';
import groupLight from '../../assets/images/bebrave-group.svg';
import groupDark from '../../assets/images/bebrave-group-dark.svg';
import { useTranslation } from 'react-i18next';

export function PaymentSuccessPage() {
    //const navigate = useNavigate();
    const { theme } = useTheme();
    const { configurationSettings } = useConfig();
    const { t } = useTranslation();

    // Refresh access token when payment is successful to get updated permissions
    useEffect(() => {
        const refreshTokenAfterPayment = async () => {
            if (configurationSettings) {
                try {
                    await refreshAccessToken(configurationSettings);
                } catch (error) {
                    console.warn('Failed to refresh access token after successful payment:', error);
                    // Don't block the user experience if token refresh fails
                }
            }
        };

        refreshTokenAfterPayment();
    }, [configurationSettings]);

    const handleStartUsingEagleGPT = () => {
        // Reload the window to ensure all stores are refreshed with updated user data
        window.location.href = '/chat';
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4 w-full">
            <div className="max-w-2xl w-full text-center space-y-8">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img
                        src={theme === 'dark' ? groupDark : groupLight}
                        alt="EagleGPT"
                        className="h-10 w-40"
                    />
                </div>

                {/* Success Icon */}
                <div className="flex justify-center">
                    <div className="w-[334px] h-[334px] flex items-center justify-center">
                        <CheckCircle className="w-48 h-48 text-success-green" strokeWidth={1} />
                    </div>
                </div>

                {/* Content */}
                <div className="space-y-8">
                    <div className="space-y-4">
                        {/* Title */}
                        <h1 className="text-[32px] font-bold leading-[48px] text-foreground font-sans">
                            {t('PAYMENT_SUCCESSFUL')}
                        </h1>

                        {/* Description */}
                        <p className="text-[20px] font-normal leading-[30px] text-muted-foreground font-sans">
                            {t('THANK_YOU_FOR_YOUR_SUBSCRIPTION')}
                        </p>
                    </div>

                    {/* Button */}
                    <div className="flex justify-center">
                        <Button
                            onClick={handleStartUsingEagleGPT}
                            className="w-[330px] h-[46px] bg-primary hover:bg-primary-600 font-semibold text-[15px] leading-[26px] rounded-md px-4 py-2.5 transition-colors"
                        >
                            {t('START_USING_EAGLEGPT')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}